import React from 'react'

const FormControlWrapper: React.FC<{
  label: string,
  children: any,
  isRequired?: boolean,
  variant: 'block' | 'inline',
  labelMinWidth?: number,
  labelFontWeight?: number,
}> = (props) => {
  return (
        <div className={`formControlWrapper ${props.variant} ${props.isRequired && 'required'}`}>
            <label
                style={{
                  minWidth: props.labelMinWidth ? props.labelMinWidth : 'auto',
                  fontWeight: props.labelFontWeight ? props.labelFontWeight : 400
                }}
                className={'formControlWrapperLabel'}>
                {props.label}
            </label>
            {props.children}
        </div>
  )
}

export default FormControlWrapper
